import React from 'react'
import intl from 'react-intl-universal'
import { LargeWrapper, Swiper } from '@raysync/common/components'
import Layout from '../../components/layout'
import DocumentCards from '../../components/document-cards'
import EnterpriseBanner from './enterprise-banner'
import { Advantages2 } from '../solutions/components'
import {
  Title,
  Desc,
  FeatureSection,
  FeatureContainer,
  ImproveBox,
  EnterpriseSection,
  ArchSection,
  DocumentSection,
} from './atoms'
import ArrowTop from '@raysync/common/components/svg/smb/arrow-1'
import ArrowBottom from '@raysync/common/components/svg/smb/arrow-2'
import Choose1 from '@raysync/common/components/svg/enterprise/choose1'
import Choose2 from '@raysync/common/components/svg/enterprise/choose2'
import Choose3 from '@raysync/common/components/svg/enterprise/choose3'
import Choose4 from '@raysync/common/components/svg/enterprise/choose4'
import Choose5 from '@raysync/common/components/svg/enterprise/choose5'
import Choose6 from '@raysync/common/components/svg/enterprise/choose6'
import Provide1 from '@raysync/common/components/svg/enterprise/provide1'
import Provide2 from '@raysync/common/components/svg/enterprise/provide2'
import Provide3 from '@raysync/common/components/svg/enterprise/provide3'
import Provide4 from '@raysync/common/components/svg/enterprise/provide4'
import Provide5 from '@raysync/common/components/svg/enterprise/provide5'
import Provide6 from '@raysync/common/components/svg/enterprise/provide6'
import Provide7 from '@raysync/common/components/svg/enterprise/provide7'
import Provide8 from '@raysync/common/components/svg/enterprise/provide8'
import Arch from '@raysync/common/components/svg/enterprise/arch'

function ProductEnterprise(props) {
  const { location } = props
  const chooseList = [
    {
      svg: <Choose5 />,
      title: intl.get('enterprise.choose.title5'),
      desc: intl.get('enterprise.choose.desc5'),
      list: intl.getHTML('enterprise.choose.list5'),
    },
    {
      svg: <Choose6 />,
      title: intl.get('enterprise.choose.title6'),
      desc: intl.get('enterprise.choose.desc6'),
      list: intl.getHTML('enterprise.choose.list6'),
    },
    {
      svg: <Choose1 />,
      title: intl.get('enterprise.choose.title1'),
      desc: intl.get('enterprise.choose.desc1'),
      list: intl.getHTML('enterprise.choose.list1'),
    },
    {
      svg: <Choose2 />,
      title: intl.get('enterprise.choose.title2'),
      desc: intl.get('enterprise.choose.desc2'),
      list: intl.getHTML('enterprise.choose.list2'),
    },
    {
      svg: <Choose3 />,
      title: intl.get('enterprise.choose.title3'),
      desc: intl.get('enterprise.choose.desc3'),
      list: intl.getHTML('enterprise.choose.list3'),
    },
    {
      svg: <Choose4 />,
      title: intl.get('enterprise.choose.title4'),
      desc: intl.get('enterprise.choose.desc4'),
      list: intl.getHTML('enterprise.choose.list4'),
    },
  ]
  const improveList = [
    {
      svg: <ArrowBottom />,
      title: intl.get('enterprise.raysync.improve1.title'),
      desc: intl.get('enterprise.raysync.improve1.desc'),
    },
    {
      svg: <ArrowTop />,
      title: intl.get('enterprise.raysync.improve2.title'),
      desc: intl.get('enterprise.raysync.improve2.desc'),
    },
    {
      svg: <ArrowBottom />,
      title: intl.get('enterprise.raysync.improve3.title'),
      desc: intl.get('enterprise.raysync.improve3.desc'),
    },
  ]
  const provideList = [
    {
      svg: <Provide1 />,
      title: intl.get('enterprise.provides.item1.title'),
      desc: intl.get('enterprise.provides.item1.desc'),
    },
    {
      svg: <Provide2 />,
      title: intl.get('enterprise.provides.item2.title'),
      desc: intl.get('enterprise.provides.item2.desc'),
    },
    {
      svg: <Provide3 />,
      title: intl.get('enterprise.provides.item3.title'),
      desc: intl.get('enterprise.provides.item3.desc'),
    },
    {
      svg: <Provide4 />,
      title: intl.get('enterprise.provides.item4.title'),
      desc: intl.get('enterprise.provides.item4.desc'),
    },
    {
      svg: <Provide5 />,
      title: intl.get('enterprise.provides.item5.title'),
      desc: intl.get('enterprise.provides.item5.desc'),
    },
    {
      svg: <Provide6 />,
      title: intl.get('enterprise.provides.item6.title'),
      desc: intl.get('enterprise.provides.item6.desc'),
    },
    {
      svg: <Provide7 />,
      title: intl.get('enterprise.provides.item7.title'),
      desc: intl.get('enterprise.provides.item7.desc'),
    },
    {
      svg: <Provide8 />,
      title: intl.get('enterprise.provides.item8.title'),
      desc: intl.get('enterprise.provides.item8.desc'),
    },
  ]
  return (
    <Layout location={location} pageType='enterprise' showBanner showH1={false}>
      <Swiper>
        <EnterpriseBanner />
      </Swiper>
      <EnterpriseSection>
        <Title>{intl.get('enterprise.raysync.title')}</Title>
        <Desc top={26}>{intl.get('enterprise.raysync.desc1')}</Desc>
        <Desc top={22}>{intl.get('enterprise.raysync.desc2')}</Desc>
        <ImproveBox>
          {improveList.map((item, index) => (
            <div key={index}>
              <span>
                {item.title}
                {item.svg}
              </span>
              <p>{item.desc}</p>
            </div>
          ))}
        </ImproveBox>
      </EnterpriseSection>
      <FeatureSection>
        <Title top={100}>{intl.get('enterprise.choose.title')}</Title>
        {chooseList.map((item, i) => {
          return (
            <FeatureContainer reverse={i % 2 === 1} key={i}>
              <div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
                <ul>{item.list}</ul>
              </div>
              {item.svg}
            </FeatureContainer>
          )
        })}
      </FeatureSection>
      <Advantages2
        useBg
        title={intl.get('enterprise.provides.title')}
        desc={intl.get('enterprise.provides.desc')}
        items={provideList}
      />
      <ArchSection>
        <Title bottom={54}>{intl.get('enterprise.arch.title')}</Title>
        <Arch />
      </ArchSection>
      <DocumentSection>
        <LargeWrapper>
          <Title>{intl.get('enterprise.document.title')}</Title>
          <DocumentCards size='large' type='product1' />
        </LargeWrapper>
      </DocumentSection>
    </Layout>
  )
}
export default ProductEnterprise
